<template>
  <div class="index">
    <div class="index_inner">
      <div class="index_banner">
        <img alt="" class="img" src="../assets/image/banner.jpg"/>
      </div>
    </div>
    <div class="index_body">
      <ProgressBar :current="progress.current" :title="progress.title"></ProgressBar>

      <div style="width: 90%; margin: 0 auto">
        <div v-if="progress.current === 1" class="input-container">
          <div class="input-item">
            <div class="input-item">
              <div class="input-item-title" style="display: inline-flex;flex-direction: row;align-items: self-end;">
                <span>出行人数</span>
                <span class="title-tips">最多可携2位家属参加，累计3人。</span>
              </div>

              <div class="input-item-inner number">
                共{{ staff.tickets.adult + 1 }}人
              </div>

              <div class="input-item-sub" style="margin-top: 20px">
                <div class="subitem-title">
                  <p class="title">随行人数</p>
                  <!--
                  <p class="tips">成人出行人数，含会员本人，最低1张。</p>
                  -->
                </div>
                <div class="input-num-btn">
                  <div>
                    <span :class="{ disabled: staff.tickets.adult <= 0 }" class="btn-minus" @click="btnTickets('minus-adult')">-</span>
                    <span class="label-num">{{ staff.tickets.adult }}</span>
                    <span :class="{disabled: staff.tickets.adult >= staff.tickets.limit,}" class="btn-add" @click="btnTickets('add-adult')">
                      +</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="body-actions">
            <button class="btn-next" @click="setNextStep()">
              确认，下一步
            </button>
          </div>
        </div>

        <div v-if="progress.current === 2" class="input-container">
          <div class="input-title">请填写您的联系方式：</div>
          <div class="input-item">
            <div class="input-item-sub" style="position: relative">
              <input v-model="staff.tel" class="input-box" placeholder="联系电话" type="tel"/>
              <span :class="valTelFormat(staff.tel) ? 'success' : 'error'" class="input-validate">
                {{
                  this.staff.tel.length === 0
                      ? "*"
                      : valTelFormat(staff.tel)
                          ? "√"
                          : "请检查格式"
                }}
              </span>
            </div>
          </div>
          <p class="tel-tips">
            如遇特殊需要，活动管理员将通过此方式与您沟通确认。
          </p>

          <div class="input-title">请准确填写您的活动体验券寄送信息：</div>
          <div class="input-item">
            <div class="input-item-sub" style="flex-direction: column">
              <div class="city_wrapper">
                <area-select v-model="staff.recCity" :data="pcaa" :level="2" :placeholders="['北京市', '市辖区', '区域']" type="text"></area-select>
              </div>
            </div>
            <div class="input-item-sub" style="position: relative">
              <input v-model="staff.recAddr" class="input-box underline" placeholder="详细收件地址" type="text"/>
              <span :class="staff.recAddr ? 'success' : 'error'" class="input-validate">
                {{ this.staff.recAddr.length === 0 ? "*" : "√" }}
              </span>
            </div>
            <div class="input-item-sub" style="position: relative">
              <input v-model="staff.recName" class="input-box underline" placeholder="收件人姓名" type="text"/>
              <span :class="staff.recName ? 'success' : 'error'" class="input-validate">
                {{ this.staff.recName.length === 0 ? "*" : "√" }}
              </span>
            </div>
            <div class="input-item-sub" style="position: relative">
              <input v-model="staff.recTel" class="input-box underline" placeholder="联系电话" type="tel"/>
              <span :class="valTelFormat(staff.recTel) ? 'success' : 'error'" class="input-validate">
                {{
                  this.staff.recTel.length === 0
                      ? "*"
                      : valTelFormat(staff.recTel)
                          ? "√"
                          : "请检查格式"
                }}
              </span>
            </div>
          </div>

          <div class="body-actions">
            <button class="btn-prev" @click="goPrevStep">上一步</button>
            <button :disabled="!canNextStep" class="btn-next" @click="setNextStep()">
              确认，下一步
            </button>
          </div>
        </div>
        <div v-if="progress.current === 3" class="input-container">
          <div class="input-item">
            <div class="input-item-inner large" style="flex-direction: column">
              <div class="input-item-sub">
                <span class="input-item-label" style="color: #666">出行人数</span>
                <div class="input-item-info">
                  <p class="info">{{ staff.tickets.adult + 1 }}人</p>
                </div>
              </div>

              <div class="input-item-sub">
                <span class="input-item-label" style="color: #666">联系方式</span>
                <div class="input-item-info">
                  <p class="info">{{ staff.tel }}</p>
                </div>
              </div>

              <div class="input-item-sub">
                <span class="input-item-label" style="color: #666">活动体验券寄送地址</span>
                <div class="input-item-info">
                  <p class="info">
                    {{ staff.recCity.join("") }}<br>
                    {{ staff.recAddr }}
                  </p>
                  <p class="info">{{ staff.recName }}</p>
                  <p class="info">{{ staff.recTel }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="body-actions">
            <button class="btn-prev" @click="goPrevStep">返回修改</button>
            <button class="btn-next" @click="submit">确认提交</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isShowDesc" class="style_info_box" @click="closeDesc">
      <div class="span_box">
        <span class="loading">Loading…</span>
      </div>
      <div class="back_box">
        <span class="span_back"><</span><span>返回上一页</span>
      </div>
      <div class="img_box style_img_box">
        <img :src="descImgUrl"/>
      </div>
    </div>

    <Error
        v-if="toggleAlert"
        :message="alertMsg"
        @close="toggleAlert = false"
    ></Error>
  </div>
</template>

<script>
import {mapState} from "vuex";
import axios from "axios";
import ProgressBar from "@/components/progressbar.vue";
import pcaa from "area-data/pcaa";
import {valTel} from "@/pages/valid";
import Error from "../components/error";

export default {
  name: "login",
  components: {
    ProgressBar,
    Error,
  },
  data() {
    return {
      datePickerCfg: {
        type: "string",
        mask: "YYYY-MM-DD",
      },
      datePickRange: {
        begin: new Date(),
        end: new Date(),
      },
      pcaa: pcaa,
      progress: {
        current: 1,
        title: "请填写您的随行人数",
      },
      toggleCalendar: false,
      toggleDialog: false,
      toggleAlert: false,
      alertMsg: "",
      submitting: false,
      retypeTel: "",

      isShowDesc: false,
      descImgUrl: "",
      descImgList: {},
      titleTpl: [
        "请填写您的随行人数",
        "请填写活动体验券接收方式",
        "请仔细核对并确认您的报名信息",
        "您已成功报名！",
      ],
    };
  },
  computed: {
    ...mapState({
      staff: (state) => state.staff,
    }),
    canNextStep() {
      //票券地址
      if (this.staff.recName.length < 1) {
        return false;
      }
      if (this.staff.recAddr.length < 1) {
        return false;
      }
      if (this.staff.recCity.length < 3 || !this.staff.recCity[2]) {
        return false;
      }
      if (!valTel(this.staff.recTel)) {
        return false;
      }
      if(!valTel(this.staff.tel)){
        return false;
      }

      return true;
    },
    childData() {
      if (this.staff.tickets.child <= 0) {
        return "";
      }

      let countData = this.staff.tickets.child_height.reduce((acc, cur) => {
        acc[cur] = (acc[cur] || 0) + 1;
        return acc;
      }, {});

      let childData = [];
      Object.entries(countData).forEach(([key, value]) => {
        childData.push(`${key} ${value}人`);
      });

      return childData;
    },
  },
  mounted() {
    if (this.staff.id.length < 5) {
      this.$router.replace({name: "login"});
    }
  },
  watch: {},
  methods: {
    setNextStep() {
      this.progress.current++;

      let title = this.titleTpl[this.progress.current - 1];
      title = title.replace("%PLACE%", this.staff.tickets.place);

      this.progress.title = title;
    },
    goPrevStep() {
      if (this.progress.current > 1) {
        this.progress.current--;
      }

      let title = this.titleTpl[this.progress.current - 1];
      title = title.replace("%PLACE%", this.staff.tickets.place);

      this.progress.title = title;
    },
    valTelFormat(val) {
      return valTel(val);
    },
    btnTickets(action) {
      console.log(action);
      if (action === "add-adult") {
        if (
            this.staff.tickets.child + this.staff.tickets.adult <
            this.staff.tickets.limit
        ) {
          this.staff.tickets.adult++;
        }
      } else if (action === "minus-adult") {
        this.staff.tickets.adult =
            this.staff.tickets.adult <= 0 ? 0 : this.staff.tickets.adult - 1;
      } else if (action === "add-child") {
        if (
            this.staff.tickets.child + this.staff.tickets.adult <
            this.staff.tickets.limit
        ) {
          this.staff.tickets.child++;
          this.staff.tickets.child_height.push("");
        }
      } else if (action === "minus-child") {
        this.staff.tickets.child =
            this.staff.tickets.child <= 1 ? 0 : this.staff.tickets.child - 1;
        this.staff.tickets.child_height.pop();
      }
    },
    showDesc(imgUrl) {
      this.isShowDesc = true;
      this.descImgUrl = this.descImgList[imgUrl];
    },
    closeDesc() {
      this.isShowDesc = false;
      this.descImgUrl = "";
    },

    setChildHeight(idx, height) {
      this.$set(this.staff.tickets.child_height, idx - 1, height);
    },

    handleSelect(place) {
      if (this.staff.tickets.place !== place) {
        this.staff.tickets.child = 0;
        this.staff.tickets.child_height = [];
        this.staff.tickets.event = "";
        if (place === "稻香湖乐园") {
          this.staff.tickets.event = "动物乐园";
        }
      }
      this.staff.tickets.place = place;
      this.setNextStep();
    },
    submit() {
      //anti jetter
      if (!this.submitting) {
        this.submitting = true;
        axios
            .post("/submit", {staff: this.staff})
            .then((rsp) => {
              this.$router.replace({name: "result"});
            })
            .catch((e) => {
              this.alertMsg = e.response.data.message;
              this.toggleAlert = true;
            })
            .finally(() => {
              this.submitting = false;
            });
      }
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../assets/mixins.styl'

.index
  width 750px
  min-height 100vh
  position relative
  margin 0 auto
  background #ecf9ff

  .index_inner
    width 750px
    height 100%

    .index_banner
      width 100%
      line-height 0

      .img
        width 100%;

  //box-shadow 10px 10px 15px rgba(0, 0, 0, 0.2);

  .index_body
    width 750px
    //height 80vh
    //position absolute
    //top 300px
    display flex
    flex-direction column
    align-items center

    .color-notice
      color #f24b52

    .input-container
      .input-calendar
        width: calc(750px * 0.8);
        z-index: 999;
        position: absolute;
        right: 0;
        top: 50px;
        display: flex;
        flex-direction: row;
        justify-content: center

      .input-item
        margin-bottom 20px

      .input-box
        width 100%
        border none
        font-size 32px
        //border-bottom solid 1px #a1a4ad
        margin 10px

        &.underline
          border-bottom solid 1px #a1a4ad

        &:focus
          outline none

      .input-validate
        position absolute
        top 20px
        right 20px
        line-height 24px

        &.success
          color #009966

        &.error
          color #f24b52

      .city_wrapper
        width 100%
        display flex
        flex-direction column
        margin-bottom 10px;

        .city_wrapper_title
          display block
          font-size 32px
          padding-bottom 20px

      &.notice
        p
          margin 0
          font-size 24px
          color #f24b52

    .input-title
      font-size 32px
      font-weight bold
      //margin-left 1em
      padding-top 20px
      padding-bottom 5px

      &:first-child
        padding-top 0

    .input-item
      width 100%
      background #ffffff
      border-radius 15px
      display flex
      flex-direction row
      flex-wrap wrap
      justify-content space-between
      fontFamily()
      font-size 30px
      padding 10px 10px
      box-sizing border-box

      .input-item-label
        color #666666

      .input-item-title
        color #000000
        font-weight bold
        font-size 36px

        .title-tips
          color #666666
          font-size 24px
          padding-left 10px
          padding-top 15px

        p.title-tips
          margin 0

        p.tips
          font-size 24px
          margin 5px 0 0 0

      .input-item-info
        flex 1
        display flex
        flex-direction column
        justify-content right

        p
          margin 0
          text-align right
          font-size 30px
          line-height 42px

      .input-item-inner
        flex 1
        display flex
        justify-content right

        input
          min-width 16em
          height 100%
          text-align right
          border none
          font-weight bold

          &::placeholder
            font-size 24px
            color #000

        input[type="checkbox"]
          width 2em
          min-width auto

        //accent-color white


        &.number
          align-items center
          color #333333
          font-weight bold
          font-size 1.4em

      .input-item-sub
        width 100%
        display flex
        flex-direction row
        margin-top 20px

        &:first-child
          margin-top 10px

        &.list
          flex-direction column

        .subitem-title
          flex 1

          p
            margin 0

          .title
            font-size 32px
            font-weight bold

            .title-tips
              color #f24b52
              font-size 24px

          .tips
            color #666666
            font-size 24px
            padding-left 10px

        .input-select
          width 100%;
          display flex
          flex-direction row
          justify-content space-between
          margin-bottom 30px

          &:last-child
            margin-bottom 0

          .label
            color #ff6600
            line-height 50px;
            vertical-align middle

          .options
            span
              display inline-block
              margin-right 40px
              padding 5px 30px;
              border-radius 30px
              background #e0e0e0
              border solid 1px #e0e0e0
              line-height 40px;
              vertical-align middle

              &:last-child
                margin-right 0

              &.selected
                color #ffffff
                background #0070c0
                border #0070c0

            &.static
              span
                color #ffffff
                background #0070c0
                border #0070c0
                margin-right 10px

                &:last-child
                  margin-right 0

          .option-tips
            width 100%
            text-align right
            color red

      .input-num-btn
        width 170px
        display inline-flex
        align-items center
        justify-content right

        .label-num
          width 1em
          display inline-block
          margin 0 10px
          font-size 36px
          font-weight bold
          text-align center
          color #333333

        .btn-add,
        .btn-minus
          width 48px
          height 48px
          line-height 42px
          font-size 48px
          font-weight bold
          display inline-block
          border solid 1px #666666
          border-radius 50%
          color #666666
          text-align center
          cursor pointer

          &.disabled
            background #dddddd

    .body-actions
      width 100%
      display flex
      margin-top 50px
      margin-bottom 50px
      flex-direction row
      justify-content space-around

      button
        font-size 36px !important

      .btn-prev
        buttonSet()
        width 300px
        background #007196
        color #e6c585

        &:disabled
          background $deepGray
          color #ffffff

      .btn-next
        buttonSet()
        width 300px
        background #007196
        color #e6c585
        &:disabled
          color #ffffff

  .input-container
    .select-place
      width 100%;
      display flex
      flex-direction column

      .place
        width 100%
        margin-bottom 30px;
        position relative

        .place-img
          width 100%

          img
            width inherit

        .select-btn
          position absolute
          width 100%
          top 160px
          display flex
          flex-direction row
          justify-content center

          .button
            buttonSet()
            scale 60%
            font-size 68px

        .place-desc
          width 100%;
          padding-top 5px
          text-align center

          span
            color #039fff
            font-size 28px

    .tel-tips
      font-size 26px;

.style_info_box
  position absolute
  top 0
  right 0
  bottom 0
  left 0
  width 100%
  height 100%
  background-color rgba(0, 0, 0, 0.6)

  .span_box
    position relative
    //background-color red
    width 100%
    height 100vh
    color white
    display flex
    align-items center
    justify-content center
    font-size 50px

  .back_box
    position fixed
    top 0
    z-index 99
    width 100%
    height 100px
    background-color white

    span
      display inline-block
      font-size 48px
      font-family()
      font-weight bold
      color #000
      line-height 100px
      padding 0 30px 0

    .span_back
      transform scale(1, 2)

  .img_box
    position absolute
    top 80px
    width 100vw
    //background-color  yellow

    img
      z-index 99
      width 100%

.ticket-tips
  width 100%
  color #f24b52
  font-style italic
  margin 10px 0 10px 0
  border-bottom dashed 5px #e1e2e6

::v-deep .vc-container {
  width 80%;
  --rounded: 15px !important
  --rounded-lg: 15px !important
}

::v-deep area-cascader-wrap {
  display inline-block
}

::v-deep .area-select {
  position: relative;
  display: inline-block;
  vertical-align: top;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 60px;
  width: 100%;
  cursor: pointer;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e1e2e6;
  margin 0
}

::v-deep .area-select-wrap {
  display inline-flex
}

::v-deep .area-select-wrap .area-select {
  margin 0 0 20px
}

::v-deep .area-select .area-selected-trigger {
  position: relative;
  display: block;
  font-size: 30px;
  cursor: pointer;
  margin: 0;
  line-height 60px;
  overflow: hidden;
  white-space: nowrap;
  //text-overflow: ellipsis;
  height: 100%;
  padding: 0 0 0 44px
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 10px;
}

::v-deep .area-selectable-list-wrap {
  max-height 500px
}

::v-deep .area-select .area-select-icon {
  border 10px solid transparent
  border-top-color: #a1a4ad;
  position: absolute;
  top: 50%;
  //margin-top: -0.026667rem;
  right: 40px;
}

::v-deep .area-selectable-list {
  font-size: 40px !important;
}

::v-deep .area-selectable-list .area-select-option {
  padding 0 0 0 44px
  font-size 30px
  height 68px
  line-height 68px
}

::v-deep .area-selectable-list .area-select-option.selected {
  background-color: #e4e8f1;
  color #333333
  font-weight: 700
}

::v-deep .cascader-menu-list .cascader-menu-option.selected {
  background-color: #e4e8f1;
  color #333333
  font-weight: 700
}

//::v-deep .cascader-menu-list .cascader-menu-option {
//  position: relative;
//  white-space: nowrap;
//  overflow: hidden;
//  text-overflow: ellipsis;
//  cursor: pointer;
//  padding: 0 15px 0 20px;
//  height: 50px;
//  line-height: 50px
//}
::v-deep .cascader-menu-list {
  position: relative;
  margin: 0;
  font-size: 26px;
  color: #565656;
  padding: 6px 0;
  list-style: none;
  display: inline-block;
  height: 430px;
  overflow-x: hidden;
  overflow-y: auto;
  min-width: 150px;
  vertical-align: top;
  background-color: #fff;
  border-right: 1px solid #e4e7ed
}
</style>
